"use client";

import { useState } from "react";
import SolarIcon from "@/components/ui/SolarIcon/SolarIcon";

export default function CopyLinkButton({
    url,
    displayUrl,
    copyLabel,
    copiedLabel,
    compact = false,
}) {
    const [copied, setCopied] = useState(false);

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(url);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        } catch (e) {
            const textArea = document.createElement("textarea");
            textArea.value = url;
            textArea.style.position = "fixed";
            textArea.style.opacity = "0";
            document.body.appendChild(textArea);
            textArea.select();
            try {
                document.execCommand("copy");
                setCopied(true);
                setTimeout(() => setCopied(false), 2000);
            } catch (err) {
                // silent
            }
            document.body.removeChild(textArea);
        }
    };

    // Variante compacte : un simple bouton secondaire, sans l'adresse, pour le
    // haut de la page.
    if (compact) {
        return (
            <button
                type="button"
                onClick={handleCopy}
                className="inline-flex cursor-pointer items-center justify-center gap-2.5 whitespace-nowrap rounded-full border border-slate-300 bg-white/70 px-5 py-3 text-sm font-semibold text-slate-900 backdrop-blur transition-colors hover:border-slate-400 hover:bg-slate-50"
            >
                <SolarIcon
                    name={copied ? "check-circle-bold" : "link-round-bold-duotone"}
                    className={`text-lg ${copied ? "text-emerald-600" : "text-primary"}`}
                />
                <span aria-live="polite">{copied ? copiedLabel : copyLabel}</span>
            </button>
        );
    }

    return (
        <button
            type="button"
            onClick={handleCopy}
            className="group inline-flex flex-col sm:flex-row items-stretch cursor-pointer bg-white/90 backdrop-blur ring-1 ring-slate-900/5 hover:ring-primary/30 transition-shadow rounded-3xl sm:rounded-full overflow-hidden shadow-[0_12px_30px_-12px_rgba(76,52,170,0.35)] w-full max-w-sm sm:max-w-none sm:w-auto"
        >
            <span className="flex min-w-0 flex-1 items-center justify-center sm:justify-start px-4 sm:px-5 py-3 font-geistMono text-[11px] sm:text-xs text-slate-600">
                <span className="truncate">{displayUrl}</span>
            </span>
            <span
                aria-hidden="true"
                className="block h-px w-full sm:h-auto sm:w-px bg-slate-900/5 group-hover:bg-primary/20 transition-colors"
            ></span>
            <span className="flex items-center gap-2 px-4 sm:px-5 py-3 m-1 rounded-full bg-primary text-white text-sm font-semibold group-hover:bg-[#d04816] transition-colors sm:min-w-[140px] shrink-0 whitespace-nowrap justify-center">
                {copied ? (
                    <>
                        <SolarIcon
                            name="check-circle-bold"
                            className="w-4 h-4 shrink-0"
                        />
                        <span>{copiedLabel}</span>
                    </>
                ) : (
                    <>
                        <SolarIcon
                            name="copy-bold-duotone"
                            className="w-4 h-4 shrink-0"
                        />
                        <span>{copyLabel}</span>
                    </>
                )}
            </span>
        </button>
    );
}
